import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

let nextUniqueId = 0;

@Component({
  selector: 'fdk-dialog-title',
  templateUrl: './dialog-title.component.html',
  styleUrl: './dialog-title.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkDialogTitleComponent {
  @Input() id = `fdk-dialog-title-${nextUniqueId++}`;
}
